import React, {useContext, useEffect, useMemo, useState} from 'react'
import useAsyncAction from "../../../modules/asyncCache/useAsyncAction";
import useTranslate from "../../../modules/local/useTranslate";
import {LoginContext} from "../../../components/LoginContext";
import {NullAsDefault} from 'views/Shared'
import {Modal, Switch} from "antd";
import {godwords_getSuggestedWords_Api} from "../../../apis/godwords";
import _ from "lodash"
import {DelayRender} from "../../Shared/components/DelayRender";
import CRUD from "../../Shared/enums/CRUD";
import {renderIf} from "../../Shared";
import {getGodWordDisplayConfigKey, setGodWordDisplayConfigKey} from "../../../helpers/localStorage";
import ResponsiveTextLabel from "../../../components/ResponsiveTextLabel/ResponsiveTextLabel";
import {Link} from "react-router-dom";
import {GodWordsDialog} from "./containers/WordOfGodDialog";
import {useHistory} from "../../../modules/navigation/useRouter";
import {getRouteSearchParams, useRouteSearchParam} from "../../../envs/_current/history";
import {RiRefreshFill} from "react-icons/ri";
import {LocalContext} from "../../../modules/local/LocalContext";
import CheckOutlined from "@ant-design/icons/lib/icons/CheckOutlined";
import CloseOutlined from "@ant-design/icons/lib/icons/CloseOutlined";
import TooltipApp from "components/TooltipApp";
import {getLinkToDetailRow} from "../Codi/codiHelpers";
import dayjs from "dayjs";

const WordsOfGod = ({children, defaultId, today = 0, ...props}) => {
    const t = useTranslate()
    const history = useHistory()
    const login = useContext(LoginContext)
    const {timezone_offset_in_hours} = useContext(LocalContext)
    const displayConfig = getGodWordDisplayConfigKey();
    const [isLatestBookmark, setLatestBookmark] = useState(Number(displayConfig) === 1)
    const [action, setAction] = useState({type: undefined, value: undefined})

    const onCancel = () => {
        const params = getRouteSearchParams()
        params.delete('popup')
        history.replace({
            search: params.toString(),
        })
        setAction({})
    }

    const popup = useRouteSearchParam('popup')

    const {response, isLoading, handleAsyncAction: fetchRandomGodWords} = useAsyncAction({
        apiInfo: godwords_getSuggestedWords_Api,
    })

    useEffect(() => {
        if (!!!action.type && popup === 'divine-word') {
            setAction({type: CRUD.READ, value: {}});
        }
        let inputParam = {limit: 1, timezone_offset_in_hours}
        if (defaultId) inputParam.id = defaultId
        if (today) inputParam.today = 1;
        fetchRandomGodWords(
            {...inputParam},
            {}
        )
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        setLatestBookmark(Number(displayConfig) === 1)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [displayConfig])

    const item = _.get(response, 'data.item');
    const data = _.get(response, 'data.data', []);

    useEffect(() => {
        if (_.isEmpty(item) && !_.isEmpty(response) && isLatestBookmark) {
            setLatestBookmark(false);
            // setGodWordDisplayConfigKey("0")
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [item])

    const modal = useMemo(() => {
        let Content = NullAsDefault
        let params = {}
        let modal_params = {}
        switch (action.type) {
            case CRUD.READ:
                params = {
                    default_id: action.value?.id
                }
                modal_params = {
                    width: 640,
                    title: (
                        <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                            {t('god word today')}
                        </div>
                    ),
                }
                Content = GodWordsDialog
                break
            default:
                break
        }

        return (
            <Modal
                footer={null}
                onCancel={onCancel}
                open={action.type}
                destroyOnHidden={true}
                className="custom-modal"
                {...modal_params}>
                <DelayRender lazy={true}>
                    <Content
                        {...{
                            onCancel,
                            item: action.value,
                        }}
                        {...params}
                    />
                </DelayRender>
            </Modal>
        )
    }, [action])

    const selectedItem = (isLatestBookmark && !!!defaultId) ? item : _.get(data, '0')

    const codi_page = _.get(selectedItem, 'codi_document_row') ?? {}

    if (children) return (
        <React.Fragment>
            <div
                onClick={() => {
                    setAction({
                        type: CRUD.READ,
                        value: selectedItem
                    })
                }}>
                {children}
            </div>
            {modal}
        </React.Fragment>
    )
    return (
        <div className="flex flex-col gap-3">
            <div className="flex items-center gap-2">
                <div className="flex flex-col flex-center flex-1">
                    <span className="font-bold text-2xl text-gray-800 tracking-wide cursor-pointer">
                        {t('god word today')}
                    </span>
                    <span className="text-color-300 italic capitalize tracking-wider">
                        {dayjs().format('dddd, DD MMMM, YYYY')}
                    </span>
                    <div className="mt-2 w-20 h-1 rounded-full bg-gray-400"/>
                </div>
                <Switch
                    size="small"
                    checked={isLatestBookmark}
                    checkedChildren={<CheckOutlined/>}
                    unCheckedChildren={<CloseOutlined/>}
                    onChange={(checked) => {
                        setGodWordDisplayConfigKey(checked ? 1 : 0)
                        setLatestBookmark(checked)
                    }}
                />
            </div>
            <div style={{minHeight: 180}}
                 className="flex flex-center cursor-pointer z-3 relative">
                {renderIf(
                    selectedItem && selectedItem?.content,
                    <div style={{minHeight: 180}} className="w-full h-full flex flex-col flex-center gap-2">
                        <div
                            onClick={() => {
                                setAction({
                                    type: CRUD.READ,
                                    value: selectedItem
                                })
                            }}
                            className="font-medium text-green-600 hover:text-primary leading-7 cursor-pointer">
                            {renderIf(
                                selectedItem?.content,
                                <ResponsiveTextLabel text={selectedItem?.content}/>
                            )}
                        </div>
                        <div className="flex flex-center gap-4">
                            <div style={{ height: 1 }} className="w-5 bg-primary-400" />
                            <Link
                                to={getLinkToDetailRow(codi_page) || "#"}
                                target="_blank"
                                className="font-semibold text-sm md:text-lg text-primary no-underline">
                                {selectedItem?.source_text}
                            </Link>
                            <div style={{ height: 1 }} className="w-5 bg-primary-400" />
                        </div>
                    </div>
                )}
            </div>
            <div className="flex justify-end">
                <TooltipApp title={t('choose words of god')} placement="left"
                            classNames={{root: "font-medium text-xs italic"}}>
                    <RiRefreshFill
                        onClick={() => {
                            fetchRandomGodWords(
                                {limit: 1, timezone_offset_in_hours, exclude_id: selectedItem?.id},
                                {}
                            )
                        }}
                        size={28}
                        className="text-green-500 hover:text-green-700 cursor-pointer"
                    />
                </TooltipApp>
            </div>
            {modal}
        </div>
    )
}

export default WordsOfGod
